module.exports = __webpack_public_path__ + "media/images/front/sp/collaboration/my_atopy_line/bg_graph-abcc995ba90c299f736465715766995f.png";